import React from "react";
import ModalUI from "@material-ui/core/Modal";
import CSS from "csstype";

export interface ModalProps {
  open: boolean;
  children: React.ReactElement;
  testId?: string;
  onClose?: () => never | void;
  style?: CSS.Properties;
}

/**
 * Modal
 */
export const Modal = ({
  open,
  onClose,
  children,
  style,
}: ModalProps): React.ReactElement => (
  <ModalUI open={open} onClose={onClose} style={style}>
    {children}
  </ModalUI>
);

/**
 * ModalScreen
 */
export const ModalScreen = ({
  open,
  children,
  testId,
}: ModalProps): React.ReactElement => (
  <Modal open={open} style={{ display: "flex", flex: 1 }}>
    <div
      data-testid={testId}
      style={{
        display: "flex",
        flex: 1,
        backgroundColor: "rgb(248,248,248,0.1)",
        alignItems: "center",
      }}>
      {children}
    </div>
  </Modal>
);
